import Modules from '@/common/modules';
import {combineReducers} from 'redux';
import authReducer from './auth-slice';
import globalReducer from './global-slice';

const rootReducer = combineReducers({
    [Modules.AUTH]: authReducer,
    [Modules.GLOBAL]: globalReducer,
});

export default rootReducer;
